import Header from "../../Header";
import MessageLink from "../../MessageLink";
import Footer from "../../Footer";
import Lgpd from "../../Lgpd";
import FormCarrossel from "../../FormCarrossel";
import ErrorBoundary from "../../ErrorHandler/ErrorBoundary";
import InfoComponent from "../InfoComponent";

const Formularios = (props: any) => {

	return (
		<div>
			{/* HEADER */}
			{/* LOGIN */}
			<ErrorBoundary>
				<Header />
			</ErrorBoundary>
			
			<InfoComponent image={"formularios"} page={'formularios'}></InfoComponent>

			{/* Content page */}
			<div className="_the-content page-formularios pb-10">

				<ErrorBoundary>
					<FormCarrossel page={"ObterFormulariosPlanoB"} title={"Plano B"}/>{" "}
				</ErrorBoundary>
				

				<ErrorBoundary>
					<FormCarrossel page={"ObterFormulariosPlanoTaesa"} title={"Plano Taesaprev"}/>
				</ErrorBoundary>
				

				<ErrorBoundary>
					<FormCarrossel page={"ObterFormulariosPlanoImposto"} title={"Isenção de Imposto de Renda"}/>
				</ErrorBoundary>
				

				<ErrorBoundary>
					<FormCarrossel page={"ObterFormulariosPlanoCemig"} title={"Seguro de vida CEMIG"}/>{" "}
				</ErrorBoundary>
				
				
			</div>
			{/* FOOTER */}
			<ErrorBoundary>
				<Footer />
			</ErrorBoundary>
			{/* Message Link */}
			<ErrorBoundary>
				<MessageLink />
			</ErrorBoundary>
			{/* LGPD */}
			<ErrorBoundary>
				<Lgpd />
			</ErrorBoundary>
		</div>
	);
};

export default Formularios;
